import { useCurrentSKU } from '../store'
import { hasActiveSKU } from '../utils/sku'

/**
 * Hook to check if the user has an active SKU
 */
export const useHasActiveSKU = () => {
	const sku = useCurrentSKU()

	return hasActiveSKU(sku)
}
